<template>
	<modal
		:adaptive="true"
		:click-to-close="true"
		:scrollable="true"
		height="auto"
		width="570"
		name="annual-sale-2020-modal"
		@before-open="routePath"
		@before-close="beforeClose"
	>
		<div class="annual-sales-modal-announcement">
			<div class="annual-sales-modal-announcement__image">
				<img src="/images/promo-sales/black-friday-reminder-modal-phase-1.jpg">
			</div>
			<div class="annual-sales-modal-announcement__content">
				<div class="annual-sales-modal-announcement__close">
					<img
						@click="closeModal"
						src="/images/icons/close-white.svg"
						alt="Close modal"
					>
				</div>
				<div v-if="!success" class="annual-sales-modal-announcement__body">
					<h2 class="annual-sales-modal-announcement__heading">
						BLACK FRIDAY IS ON THE HORIZON
					</h2>
					<div class="annual-sales-modal-announcement__time">
						<annual-sale-2020-countdown
							:current-phase="currentPhase"
							:phases="phases"
							:time-zone="timeZone"
						/>
					</div>
					<div class="annual-sales-modal-announcement__subtitle">
						10% off any BLD purchase
					</div>
					<hr >
					<div class="annual-sales-modal-announcement__label-errors">
						<p
							v-if="!errors.first('emailOrPhone')"
							class="annual-sales-modal-announcement__input__label"
						>
							Remind me when the sale starts via email or text message:
						</p>
						<span class="error text-danger">
							{{ errors.first("emailOrPhone") }}
						</span>
					</div>
					<div class="annual-sales-modal-announcement__input__error-container">
						<div class="annual-sales-modal-announcement__input__container">
							<input
								v-model="emailOrPhone"
								v-validate="'required|emailOrPhone'"
								name="emailOrPhone"
								type="text"
								class="annual-sales-modal-announcement__input"
							>
							<button
								@click="send"
								class="annual-sales-modal-announcement__input__button"
							>
								<img src="/images/icons/right-arrow-white-icon.svg" alt="Right arrow">
							</button>
						</div>
					</div>
					<div class="annual-sales-modal-announcement__condition">
						Enter your email or phone number to receive a one-time-only reminder. Please note US and Canadian numbers only. Carrier text rates may apply.
					</div>
				</div>
				<div class="annual-sales-modal-announcement__success-state">
					<div>
						<img src="/images/icons/orchid-check.svg" alt="Check icon">
						<h2>Success</h2>
					</div>
					<p>
						We’ll send you a reminder when the Sale begins!
					</p>
					<p>
						Feel free to set another reminder for family and friends who might be interested in the sale.
					</p>
				</div>
			</div>
		</div>
	</modal>
</template>

<script>
import { serialize } from "object-to-formdata";
import { Validator } from "vee-validate";
import AnnualSale2020Countdown from "./annual-sale-2020-countdown";

const phoneRegex = /^(1?\W*([2-9][0-8][0-9])\W*([2-9][0-9]{2})\W*([0-9]{4})(\se?x?t?(\d*))?)$/;

export default {
	name: "AnnualSale2020Modal",
	components: {
		AnnualSale2020Countdown
	},
	props: {
		currentPhase: {
			type: [String, Number],
			required: true
		},
		phases: {
			type: [Object, Array],
			default() {
				return [];
			}
		},
		timeZone: {
			type: String,
			default: "America/Los_Angeles"
		}
	},
	data() {
		return {
			emailOrPhone: "",
			excludedRouteNames: [
				"h1-mini-pc",
				"starter-series",
				"starter-pc",
				"streaming-pc",
				"creator-pc",
				"step4",
				"step5"
			],
			staterSeries: [
				"starter",
				"starter-plus",
				"starter-pro"
			],
			source: "all_sections",
			success: false
		};
	},
	mounted() {
		const emailOrPhoneRule = {
			getMessage() {
				return "Invaild email or phone number:";
			},
			async validate(value) {
				const emailRule = new Validator();
				const { valid } = await emailRule.verify(value, "email");
				return valid || phoneRegex.test(value);
			}
		};

		const dictionary = {
			en: {
				custom: {
					emailOrPhone: {
						required: "Your email or phone number is required:"
					}
				}
			}
		};

		Validator.extend("emailOrPhone", emailOrPhoneRule);
		Validator.localize(dictionary);
	},
	methods: {
		beforeClose() {
			this.success = false;
			this.emailOrPhone = "";
			this.source = "all_sections";
			this.$emit("modal-closed");
		},
		closeModal() {
			this.$modal.hide("annual-sale-2020-modal");
		},
		routePath() {
			this.excludedRouteNames.forEach(key => {
				if (this.$route.path.includes(key)) {
					if (key.includes("step4") || key.includes("step5")) {
						this.source = "configurator";
						return;
					}
					this.source = key.replace(/-/gi, "_");
				}
			});
		},
		async send() {
			const isValid = await this.$validator.validateAll();

			if (!isValid) {
				return;
			}

			if (phoneRegex.test(this.emailOrPhone)) {
				this.sendPhoneSubscription();
			} else {
				this.sendEmailSubscription();
			}
		},
		async sendEmailSubscription() {
			let identify = {
				"g": "Sf6MYs",
				"$fields":
					"$source, $email, bfcw_subscription, $consent_method, $consent_form_id, $consent_form_version, bfcw_2020_configurator_step, bfcw_2020_bld_number, bfcw_2020_selected_starter_prebuild",
				"$email": this.emailOrPhone,
				"$source": "bfcw_2020",
				"bfcw_subscription": this.source,
				"$consent_method": true,
				"$consent_form_id": true,
				"$consent_form_version": true
			};

			if (this.source == "configurator") {
				identify = {
					...identify,
					"bfcw_2020_configurator_step": `${ this.$route.name }`,
					"bfcw_2020_bld_number": localStorage.getItem("session-draft")
				};
			}

			if (this.source == "starter_series") {
				identify = { ...identify, "bfcw_2020_selected_starter_prebuild": this.staterSeries[localStorage.getItem("starter_prebuild_id") - 1] };
			}

			await axios({
				url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
				method: "POST",
				data: serialize(identify),
				headers: { "Content-Type": "multipart/form-data" }
			});

			this.success = true;
		},
		sendPhoneSubscription() {
			const formData = new FormData();

			if (this.source == "all_sections") {
				this.source = "all-sections";
				formData.append("phone_number", this.emailOrPhone);
			} else {
				this.source = this.source.replace(/_/gi, "-");
				formData.append("phone_number", this.emailOrPhone);
				if (this.source == "configurator") {
					formData.append("bfcw_2020_configurator_step", `${ this.$route.name }`);
					formData.append("bld_number", localStorage.getItem("session-draft"));
				}
				if (this.source == "starter-series") {
					formData.append("selected_starter_prebuild", this.staterSeries[localStorage.getItem("starter_prebuild_id") - 1]);
				}
			}

			axios({
				method: "POST",
				url: `/phone-messages/bfcw-2020-${ this.source }/subscribe`,
				data: formData
			}).then(() => {
				this.success = true;
			});
		}
	}
};
</script>

<style lang="scss">
.v--modal-overlay[data-modal="holiday-modal"] {
	background-color: rgba(0, 0, 0, 0.65);

	.v--modal-box {
		max-width: 100%;
	}

	.v--modal {
		box-shadow: none;
		background-color: #252525;
	}

	.modal-dialog {
		top: -130px;

		@media screen and (max-width: 680px) and (min-width: 320px) {
			top: -46px !important;
		}
	}
}
</style>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.annual-sales-modal-announcement {
	border-radius: 2px;
	background-color: #252525;
	box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.5);
	display: flex;
	color: $white;
	max-height: 515px;

	.error {
		display: block;
		font-size: 16px;
		text-align: left;
		margin: 0;
	}

	&__image {
		max-width: 175px;
		flex-shrink: 0;

		@media (max-width: 580px) {
			display: none;
		}

		img {
			height: 100%;
			width: 100%;
		}
	}

	&__close {
		display: flex;
		justify-content: flex-end;

		img {
			margin-top: 15px;
			margin-right: 15px;
			cursor: pointer;
		}
	}

	&__content {
		text-align: center;
		width: 100%;
	}

	&__body {
		padding: 15px 30px 30px;

		@media (max-width: 500px) {
			padding: 15px 15px 30px;
		}
	}

	&__heading {
		font-family: Akkurat-Light;
		font-size: 24px;
		font-weight: 300;
		letter-spacing: 1.13px;
		line-height: 26px;
		text-transform: uppercase;
		margin: 0 0 5px;
	}

	&__time {
		margin: 0 auto 10px;
	}

	&__subtitle {
		opacity: 0.8;
		font-size: 20px;
		text-transform: uppercase;
	}

	&__label-errors {
		height: 45px;
		margin-bottom: 10px;
		display: flex;
		align-items: center;

		.error.text-danger {
			font-size: 16px;
		}
	}

	&__input__label {
		text-align: left;
		font-size: 16px;
		margin: 0;
	}

	&__input__error-container {
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		margin-bottom: 10px;
	}

	&__input__container {
		display: flex;
	}

	&__input {
		height: 55px;
		border-radius: 2px;
		background-color: rgba(255, 255, 255, 0.24);
		border: none;
		flex: 1;
		padding: 15px;
		font-size: 16px;
		font-weight: bold;

		&[aria-invalid="true"] {
			border: 2px solid #d0021b;
			transition: all 0.2s;
		}
	}

	&__input__button {
		background-color: #efefef;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-left: 15px;
		width: 55px;
		color: $oldpurple;
		font-size: 28px;
		border-radius: 2px;
		outline: none;
		border: none;
	}

	&__condition {
		opacity: 0.8;
		font-size: 12px;
		line-height: 21px;
		text-align: left;
	}

	.text-danger {
		color: #d0021b;
		font-size: 14px;
	}

	&__success-state {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		text-align: left;
		padding: 35px;

		div {
			display: flex;
			margin-bottom: 40px;
		}

		h2 {
			margin: 0;
			text-transform: uppercase;
			font-size: 24px;
			font-weight: 300;
			letter-spacing: 1.13px;
			font-family: Akkurat-Light;
		}

		img {
			margin-right: 5px;
		}

		p {
			font-family: Akkurat-Light;
			font-size: 16px;
			font-weight: 300;
			letter-spacing: 1.13px;
			line-height: 21px;
			margin-bottom: 20px;
		}

		p:last-child {
			margin-bottom: 60px;
		}
	}
}
</style>
